import { moderationDashModuleQuery, useModule } from 'system/structure-modules';

export default function ModerationDashboardPostsScreen() {
    const { AllPostsScreen } = useModule(moderationDashModuleQuery);
    return <AllPostsScreen />;
}
